// ink-component
import React, { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import getGlobalProps from '../../helpers/constants/global-props';
import { SubsetWrapper } from './styles';

export interface SubsetProps {
  /** Content */
  children: ReactNode;
  /** Content indentation */
  indent: 1 | 2 | 3 | 4;
}

const globalProps = getGlobalProps({});

/**
 * @purpose Groups and indents a subset of field children
 * @categories layout
 */
function Subset(props: SubsetProps) {
  const { children, indent } = props;

  return (
    <ThemeProvider
      theme={currentTheme => ({
        ...currentTheme,
        indent,
      })}
    >
      <SubsetWrapper data-testid={props['data-testid']} {...globalProps}>
        {children}
      </SubsetWrapper>
    </ThemeProvider>
  );
}

Subset.defaultProps = {
  indent: 1,
};

Subset.displayName = 'Subset';

export default Subset;
